<div>
  <h1>Exempel</h1>
  <button mat-button (click)="rand()">Snurra</button>
  <button mat-button (click)="print()">Skriv ut</button>
  @if (url()) {
    <p>Dokument med id: <a [href]="url()" target="_blank">{{ id() }}</a></p>
  }
  <div class="main">
    <div>
      <h2>Nuvarande</h2>
      <spb-pie [data]="pies()[0]"/>
      <spb-bar [data]="bars()[0]"/>
    </div>
    <div>
      <h2>Framtiden</h2>
      <spb-pie [data]="pies()[1]"/>
      <spb-bar [data]="bars()[1]"/>
    </div>
  </div>
</div>